import React, { useCallback, useEffect, useState } from 'react'

import { api, request } from '../../util/handlerRequestUtil'
import CustomSelect from '../CustomSelect/customSelect'

const SelectOrganization = ({
  field,
  errors = {},
  onChangeWithField,
  setFieldValue,
  formValues,
  handleBlur,
  rowSpan = 5,
  label,
  disabled = false,
  required = false,
  todos = true
}) => {
  const [selectValues, setSelectValue] = useState([])

  useEffect(() => fetchOrganizations(), [])

  const fetchOrganizations = useCallback(() => {
    request(api.listOrganizationsDropDown({ active: true, todos })).then((data) => {
      setSelectValue(data)
    })
  }, [])

  return (
    <CustomSelect
      showSearch
      label={label}
      field={field}
      errors={errors}
      setFieldValue={setFieldValue}
      rowSpan={rowSpan}
      value={formValues}
      values={selectValues}
      handleBlur={handleBlur}
      onChangeWithField={onChangeWithField}
      enable={disabled}
      required={required}
    />
  )
}

export default SelectOrganization
